import { Component, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import * as numeral from 'numeral';

import { CommonDataService } from 'app/services/common-data.service';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { ChangeBufferItem } from 'app/buffer-graph/models/chage-buffer-item';

@Component({
  selector: 'change-buffer',
  templateUrl: './change-buffer.component.html',
  styleUrls: ['./change-buffer.component.css']
})
export class ChangeBufferComponent implements AfterViewChecked {
    constructor(private readonly commonData: CommonDataService, private readonly graphService: BufferGraphService) {
        this.close = new EventEmitter<void>();
    }

    @Input()
    private itemId: number;

    @Input()
    private item: ChangeBufferItem;

    @Output()
    private readonly close: EventEmitter<void>;

    private shown: boolean;

    private showLoadingImg: boolean;

    private temporaryHidden: boolean;

    private set newBuffer(value: string) {
        this.item.newBuffer = +value;
    }

    ngAfterViewChecked(): void {
        if (this.shown)
            return;

        this.showModal();
        this.shown = true;
    }

    private showModal = (): void => {
        $('#bg-change-buffer')/*.on('shown.bs.modal',
            (e) => {
                $(e.target).off('shown.bs.modal');
            })*/.on('hidden.bs.modal',
            (e) => {
                $(e.target).off('hidden.bs.modal');

                if (!this.temporaryHidden)
                    this.close.emit();
                else
                    this.temporaryHidden = false;
            }).modal({ backdrop: 'static', keyboard: false });
    }

    private hideModal = (): void => {
        $('#bg-change-buffer').modal('hide');
    }

    private showErrors = (errors: string[], onOk?: () => void): void => {
        this.temporaryHidden = true;
        this.hideModal();
        this.commonData.showErrors(errors, onOk || this.showModal);
    }

    private changeBuffer = (): void => {
        if (!this.item.newBuffer || this.item.buffer === this.item.newBuffer)
            return;

        this.showLoadingImg = true;

        this.graphService.changeBuffer(this.itemId, this.item.newBuffer, this.item.reason).subscribe(data => {
            if (data == null || data.accessDenied || !data.success) {
                this.showLoadingImg = false;

                this.commonData.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'ChangeBufferError')
                    .subscribe(error => this.showErrors([error]));
                return;
            }

            this.hideModal();
        },
            e => {
                this.showLoadingImg = false;
                this.showErrors([e.message || e]);
            });
    }

    private onChangeBufferClick = (): void => {
        this.changeBuffer();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/change-buffer.component/change-buffer.component.ts